import { View } from "ui/atoms/view";
import GoBack from "ui/molecules/common/GoBack";
import { useLocalSearchParams, usePathname } from "expo-router";
import { MedicationLogContent } from "../../../features/medications/molecules/MedicationLogContent";
import { useGetMedicationReportQuery } from "../../../services/api/medicationsApi";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { Text } from "react-native";

export default function MedicationLogDetailedView() {
  const pathname = usePathname();
  const newPath = pathname.split("/").slice(0, -1).join("/");

  const { id, medicationLogId } = useLocalSearchParams();

  const { data, isFetching } = useGetMedicationReportQuery({
    filter: {
      resident_id: Number(id),
    },
  });

  const log = data?.data?.find((log) => log.id === Number(medicationLogId));

  if (isFetching) {
    return <LoadingSpinner />;
  }

  if (!log) {
    return <Text>Medication log not found.</Text>;
  }

  return (
    <View className="resident-container pb-10">
      <View className="items-start mb-7">
        <GoBack path={newPath} />
      </View>

      <MedicationLogContent medicationLog={log} />
    </View>
  );
}
